import * as React from "react";

function SvgShare(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="Share_svg__r-4qtqp9 Share_svg__r-yyyyoo Share_svg__r-1xvli5t Share_svg__r-dnmrzs Share_svg__r-bnwqim Share_svg__r-1plcrui Share_svg__r-lrvibr Share_svg__r-1hdv0qi"
      width="0.8em"
      height="0.8em"
      {...props}
    >
      <path d="M17.53 7.47l-5-5a.749.749 0 00-1.06 0l-5 5a.749.749 0 101.06 1.06l3.72-3.72V15a.75.75 0 001.5 0V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22a.749.749 0 000-1.06z" />
      <path d="M19.708 21.944H4.292A2.294 2.294 0 012 19.652V14a.75.75 0 011.5 0v5.652c0 .437.355.792.792.792h15.416a.793.793 0 00.792-.792V14a.75.75 0 011.5 0v5.652a2.294 2.294 0 01-2.292 2.292z" />
    </svg>
  );
}

export default SvgShare;
